import React, { Suspense, useEffect, useState } from 'react'
import './style.scss'
import { mixPostV1 } from 'services/mixin'
import Layout from 'Layout'
import ScrollUnlocker from 'components/FixScroll/ScrollUnlocker'
import { Link, useNavigate } from 'react-router-dom'
import { ArrowRightOutlined, LinkOutlined } from "@ant-design/icons";
import { useTranslation } from 'react-i18next'
import { Download } from 'lucide-react'


const Numerology = () => {

  const [getName, setGetName] = useState<string>('Nguyễn văn An')
  const [getBirth, setGetBirth] = useState<string>('')
  const [dataList, getDataList] = useState<any>()
  const [today, setToday] = useState<string>('')
  const { t } = useTranslation();
  const navigate = useNavigate();

  const SvgExample = React.lazy(() => import("./SVGExample"));

  const getToday = () => {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    setToday(`${dd}/${mm}/${yyyy}`);
  };

  const getData = async () => {
    // const res = await mixPostV1('/api/v1/pwi/calculate', {
    //   full_name: getName,
    //   date_of_birth: getBirth,
    //   current_date: getToday
    // })

    const newDate = getBirth.replaceAll("-", "/");

    const res = await mixPostV1('/api/v1/be/numerology/calculate', {
      full_name: getName,
      date_of_birth: newDate,
      current_date: today,
      locale: 'en'
    })

    if (res.success) {
      getDataList(res.data)
    }
  }

  function formatDate(dateString: string) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // tháng tính từ 0
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  function checkUserData() {
    const localeData = localStorage.getItem('user')
    if (localeData) {
      const handleData = JSON.parse(localeData)
      return handleData.first_name && handleData.last_name && handleData.birthday
    }
    return false
  }

  const handleDataDate = () => {
    const localeData = localStorage.getItem('user')
    getToday()

    if (localeData) {
      const handleData = JSON.parse(localeData)

      const lang = localStorage.getItem('i18nextLng')
      
      if (lang === 'en') setGetName(`${handleData.first_name} ${handleData.last_name}`)
      if (lang === 'vi') setGetName(`${handleData.last_name} ${handleData.first_name}`)

      const handleDate = handleData.birthday ? formatDate(handleData.birthday) : ''
      setGetBirth(handleDate)
    }
  }

  useEffect(() => {
    handleDataDate()
  }, [])

  useEffect(() => {
    if (getBirth) {
      getData()
    }
  }, [getBirth])

  return (
    <Layout>
      <ScrollUnlocker />
      <div className="wrap-page">
        <div className="container">
          <div className="slit-page">
            <div className="left-block">
              <h6>{t('TBITile')}</h6>
              <h1>
                {t('TBIDesc1_1')} <br />
                <span>{t('TBIDesc1_2')}</span> <br />
                {t('TBIDesc1_3')}
              </h1>
              <div className="form-getdata">
                <ul>
                  <li>
                    <label>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                      </svg>
                    </label>
                    <span>{t('TBIDesc2')}</span>
                  </li>
                  <li>
                    <label>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                      </svg>
                    </label>
                    <span>{t('TBIDesc3')}.</span>
                  </li>
                  <li>
                    <label>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                      </svg>
                    </label>
                    <span>{t('TBIDesc4')}.</span>
                  </li>
                </ul>
                {/* <div className="title-form">Online Numerology Lookup</div> */}
                {/* <div className="wrap-inputs">
                  <div className="name-input">
                    //<label htmlFor="">Full Name</label>
                    <input type="text" value={getName} onChange={(e) => setGetName(e.target.value)} />
                  </div>
                  <div className="birth-input">
                    <label htmlFor="">Birthday</label> */}
                {/* <input type="text" value={getBirth} onChange={handleBirthChange} /> */}
                {/* <DatePicker
                      style={{ width: '100%' }}
                      format="DD-MM-YYYY"
                      value={getBirth ? dayjs(getBirth, "DD/MM/YYYY") : null}
                      onChange={(_, dateString) => {
                        setGetBirth(dateString as string);
                      }}
                    /> */}
                {/* </div>
                </div> */}
                {/* <div className="wrap-btn-search">
                  <button onClick={getData}>
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                      <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                    </svg>
                    Check Now
                  </button>
                </div> */}
              </div>
              <div className="mt-8 flex flex-col gap-4">
                <div
                  className="flex items-center justify-center gap-2 rounded-full bg-[linear-gradient(90deg,rgba(131,58,180,1)_0%,rgba(253,29,29,1)_50%,rgba(252,176,69,1)_100%)] px-6 py-3 text-xs font-semibold text-white shadow-lg"
                >
                  {t('TBIGetStarted')}
                  <ArrowRightOutlined className="text-lg" />
                </div>
                
                <div className='flex flex-row gap-2'>
                  <button
                    className="flex items-center justify-center gap-2 rounded-full border-2 border-blue-400 px-6 py-3 text-lg font-semibold text-blue-500 hover:bg-blue-500 hover:!text-white transition-all duration-300"
                    onClick={() => {
                      navigate('/numerologist-products');
                    }}
                  >
                    <LinkOutlined className="text-xl" />
                    {t('GotoRecommendation')}
                  </button>
                  <button 
                    disabled={!checkUserData()}
                    className={`flex items-center justify-center gap-2 rounded-full border-2 border-green-400 px-6 py-3 text-lg font-semibold text-green-500  transition-all duration-300 ${!checkUserData() ? 'opacity-50 cursor-not-allowed hover:bg-gray-200' : ' hover:bg-green-500 hover:!text-white '}`}
                    onClick={() => {
                      navigate('/TBI_pdf')
                    }}
                  >
                    <Download className="text-xl" />
                    { !checkUserData() ? t('TBICompleteProfile') : t('TBIDownloadFullReport')}
                  </button>
                </div>
              </div>

            </div>

            <div className="right-block">
              {dataList && getBirth ? (
                <Suspense fallback={<div>{t('loading')}</div>}>
                  <SvgExample dataList={dataList} />
                </Suspense>
              ) : (
                <div className='wrap-btn-checknow'>
                  <p>{t('TBIUpdatebirthDate')}</p>
                  <div className="wrap-btn-search">
                    <Link to='/profile'>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                      </svg>
                      {t('UpdateNow')}
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Numerology